import { GetStaticPropsContext, GetStaticPropsResult } from "next";
import { useRouter } from "next/router";
import { SSRConfig } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import MDXPageEN from "@components/projects/projects_en";
import MDXPagePL from "@components/projects/projects_pl";
import {
  BlogContext,
  BlogContextInterface,
  BlogInterfaceData,
} from "@context/BlogContext";
import { getPosts } from "@lib/blog";

interface StaticProps {
  allPosts: BlogInterfaceData[];
}

export const getStaticProps = async ({
  locale,
}: GetStaticPropsContext): Promise<
  GetStaticPropsResult<StaticProps | SSRConfig>
> => ({
  props: {
    allPosts: BlogContextInterface.postsToBlogInterfaceData(
      await getPosts(),
      locale ?? "en",
    ),
    ...(await serverSideTranslations(locale ?? "en", ["common"])),
  },
});

const ThemedPage = () => {
  const { locale } = useRouter();

  return <>{locale === "pl" ? <MDXPagePL /> : <MDXPageEN />}</>;
};

export default function Projects({ allPosts }: StaticProps) {
  return (
    <BlogContext.Provider value={new BlogContextInterface(allPosts)}>
      <ThemedPage />
    </BlogContext.Provider>
  );
}
